let tilesetLayer;
let inDepthInspectionVal = true;
let normalShutdown = false; // 标记是否为点击关闭按钮后退出。
export default {
  // inject:['marsMap','marsMeasure'],
  props: ["xTranslation", "yTranslation", "zTranslation"],
  data() {
    return {
      modelTranslation_show: true,
      xTranslationNumber: 0,
      yTranslationNumber: 0,
      zTranslationNumber: 0,
      depthInspectionVal: true,
      isFold: false,
    };
  },
  methods: {
    adjustXTranslation(currentValue, oldValue) {
      // alert("触发！");
      //this.$emit('changeHeightInterval', this.heightIntervalNumber);
      let that = this;
      let cRes = this.checkInfo();
      if (!cRes) {
        setTimeout(function () {
          that.xTranslationNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.xTranslationNumber);
      this.modelMatrixTransformation();
    },
    adjustYTranslation(currentValue, oldValue) {
      // alert("触发！");
      //this.$emit('changeHeightInterval', this.heightIntervalNumber);
      let that = this;
      let cRes = this.checkInfo();
      if (!cRes) {
        setTimeout(function () {
          that.yTranslationNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.yTranslationNumber);
      this.modelMatrixTransformation();
    },
    adjustZTranslation(currentValue, oldValue) {
      // alert("触发！");
      //this.$emit('changeHeightInterval', this.heightIntervalNumber);
      let that = this;
      let cRes = this.checkInfo();
      if (!cRes) {
        setTimeout(function () {
          that.zTranslationNumber = oldValue;
        }, 100);
        return false;
      }
      console.log(this.zTranslationNumber);
      this.modelMatrixTransformation();
    },
    //将开启深度检测功能移到了设置面板里了。
    checkInfo() {
      //alert(window.sessionStorage.getItem('currentLayerId'));
      let currentLayerId = window.sessionStorage.getItem("currentLayerId");
      //alert(currentLayerId)
      if (currentLayerId) {
        //alert(currentLayerId)
        // try{
        tilesetLayer = this.$GLOBAL.map.getLayerById(currentLayerId);
        if (!tilesetLayer) {
          this.$alert(
            "请先在页面模型树里勾选并点击您要平移的模型。",
            "友情提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              callback: (action) => {},
            }
          );
          return false;
        } else {
          tilesetLayer.flyTo();
        }
        // }catch(err){
        // 	console.log('捕获到异常：',err);
        // 	this.$alert('请先在页面模型树里勾选并点击您要平移的模型。', '友情提示', {
        // 		confirmButtonText: '确定',
        // 		type: "warning",
        // 		callback: action => {}
        // 	});
        // 	return false;
        // }
      } else {
        this.$alert(
          "请先在页面模型树里勾选并点击您要平移的模型。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
        return false;
      }
      return true;
    },
    modelMatrixTransformation() {
      //模型矩阵变换
      //创建平移矩阵方法二
      if (tilesetLayer) {
        let translation = Cesium.Cartesian3.fromArray([
          this.xTranslationNumber,
          this.yTranslationNumber,
          this.zTranslationNumber,
        ]);
        tilesetLayer.tileset.modelMatrix =
          Cesium.Matrix4.fromTranslation(translation);
      }
    },
    modelTranslationBox_close() {
      //关闭弹窗则重置模型位置
      this.xTranslationNumber = 0;
      this.yTranslationNumber = 0;
      this.zTranslationNumber = 0;
      this.modelMatrixTransformation();
      normalShutdown = true;
      this.$emit("modelTranslationBox_close");
      // this.transparency_show = false;
    },
  },
  mounted() {
    if (this.xTranslation || this.xTranslation === 0) {
      this.xTranslationNumber = this.xTranslation;
    }
    if (this.yTranslation || this.yTranslation === 0) {
      this.yTranslationNumber = this.yTranslation;
    }
    if (this.zTranslation || this.zTranslation === 0) {
      this.zTranslationNumber = this.zTranslation;
    }

    // if(this.depthInspection===true||this.depthInspection===false){
    // 	this.depthInspectionVal=this.depthInspection;
    // }

    this.depthInspectionVal = true;
    inDepthInspectionVal = true;

    let cRes = this.checkInfo();
    if (!cRes) {
      return false;
    }
  },
  watch: {},
  destroyed() {
    //关闭弹窗后则复原深度检测默认显示。

    if (!normalShutdown) {
      this.xTranslationNumber = 0;
      this.yTranslationNumber = 0;
      this.zTranslationNumber = 0;
      this.modelMatrixTransformation();
    }
  },
};
